import { IPartnerModel } from 'models';
import Image from 'next/image';
import React from 'react';

import styles from './partner-card.module.scss';

type Props = {
  partner: IPartnerModel;
};

export default function PartnerCard({ partner }: Props) {
  if (!partner) return <></>;

  return (
    <a href={partner.siteWebUrl} target="_blank" rel="noreferrer">
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles['wrapper-logo']}>
            <Image
              src={partner.logoUrl}
              alt={partner.name}
              className={styles.logo}
              layout="fill"
              objectFit="contain"
              unoptimized
            />
          </div>
          <div className={styles['image-caption']}>{partner.description}</div>
        </div>
      </div>
    </a>
  );
}
